var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-marker"},[_c('div',{staticClass:"counter-marker__container"},[_c('div',{staticClass:"mark-group"},_vm._l((_vm.count),function(i){return _c('mark-item',{key:i,attrs:{"active":_vm.active === i - 1},on:{"click":function($event){return _vm.$emit('click', i - 1)}}})}),1),_vm._v(" "),_c('dynamic-arrow',{attrs:{"transform":_vm.active,"count":_vm.count}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f84e7b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CounterMarks/CounterMarks.vue
// module id = 76
// module chunks = 0